var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-warpper",class:{ [_vm.align]: true }},[_c('h2',[_vm._v(_vm._s(_vm.title))]),(!!_vm.en)?_c('p',[_vm._v(_vm._s(_vm.en))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }